/**
 * Stanje stranice Ugovori u adresi (hash router: /#/ugovori?t=pending&s=unverified).
 * Prvi tab i "sve" se izostavljaju. ?ui=stari vraća staru stranicu (isti naziv kao u finansijama i firmama dostave).
 */
export const CONTRACTS_QUERY = { tab: "t", status: "s", legacy: "ui" };

export const LEGACY_UI_VALUE = "stari";

export const CONTRACT_TABS = ["overview", "pending"];
export const DEFAULT_TAB = "overview";

/** filteri pregleda ugovora (brojke na vrhu) */
export const OVERVIEW_FILTERS = ["expired", "expiring", "valid", "none"];

/** filteri radnog spiska cjenovnika (grupe iz /pricing/pending-verification) */
export const PENDING_FILTERS = ["missing", "no_amount", "unverified", "contract_expired", "contract_expiring", "ok"];
